import { api, initCsrf } from '@/lib/api/client'
import type { SessionUser } from '@/types/domain'

export async function login(email: string, password: string): Promise<SessionUser> {
  // Sanctum hands out the XSRF cookie first; every mutating call needs it.
  await initCsrf()
  const { data } = await api.post<{ data: SessionUser }>('/login', { email, password })

  return data.data
}

export async function logout(): Promise<void> {
  await api.post('/logout')
}

export interface SessionOrganization {
  key: string | null
  name: string | null
}

export interface Session {
  user: SessionUser
  isOwner: boolean
  reachableProjects: number | 'all'
  /** The tenant names itself; the client never hard-codes it. */
  organization: SessionOrganization
}

export async function fetchSession(): Promise<Session> {
  const { data } = await api.get<{
    data: SessionUser
    meta: { isOwner: boolean; reachableProjects: number | 'all'; organization: SessionOrganization }
  }>('/me')

  return { user: data.data, ...data.meta }
}
